var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3584_1141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3584_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9135 18.8631L12.1562 13.1055C11.6978 13.4839 11.1707 13.7801 10.5749 13.994C9.97908 14.2079 9.36269 14.3148 8.72576 14.3148C7.15903 14.3148 5.83307 13.7724 4.74789 12.6875C3.66271 11.6026 3.12012 10.277 3.12012 8.71054C3.12012 7.14426 3.66255 5.81815 4.74743 4.7322C5.8323 3.64641 7.15796 3.10352 8.72439 3.10352C10.2907 3.10352 11.6168 3.64611 12.7027 4.73129C13.7885 5.81647 14.3314 7.14243 14.3314 8.70916C14.3314 9.36381 14.2216 9.98906 14.0019 10.5849C13.782 11.1807 13.4888 11.6989 13.1221 12.1396L18.8795 17.8969L17.9135 18.8631ZM8.72576 12.94C9.90689 12.94 10.9073 12.5301 11.7269 11.7103C12.5467 10.8907 12.9566 9.89029 12.9566 8.70916C12.9566 7.52804 12.5467 6.52765 11.7269 5.70799C10.9073 4.88819 9.90689 4.47829 8.72576 4.47829C7.54464 4.47829 6.54425 4.88819 5.7246 5.70799C4.90479 6.52765 4.49489 7.52804 4.49489 8.70916C4.49489 9.89029 4.90479 10.8907 5.7246 11.7103C6.54425 12.5301 7.54464 12.94 8.72576 12.94Z",
    fill: "#8C959F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.a74830668c4a12b909355be943cf7b99.svg";
export { ForwardRef as ReactComponent };